<template>
  <div>
    <CommonBreadCrumbs :data="breadcrumbs"> </CommonBreadCrumbs>
    <div>
      <NuxtLayout name="center">
        <div class="text-center mb-20">
          <h1>{{ headerData.title }}</h1>
          <div
            class="p-quote-blog-intro-text mt-16 mb:mt-20 mb-4 text-left md:text-center"
          >
            <div
              v-if="isArrayOfObjects"
              v-for="(content, key) in headerData.body_text"
            >
              <div v-if="content.type == 'text'" v-html="content.text"></div>
            </div>
            <div v-else v-html="headerData.body_text"></div>
          </div>
        </div>
      </NuxtLayout>

      <div class="bg-secondary-lighter py-8" v-if="legalLists.length > 0">
        <NuxtLayout name="center">
          <div class="md:m-4">
            <h2 class="text-center md:text-left mb-8">
              {{ $t("legalandPolicies.topicLabel") }}
            </h2>
            <CommonTopicCard :list="legalLists" card_type="legal-and-privacy" />
          </div>
        </NuxtLayout>
      </div>
    </div>
  </div>
</template>

<script setup>
const headerData = ref();
const bodyTextContent = ref();
const legalLists = ref([]);
const { data: legalIntro } = await useLegalIntro();
headerData.value = legalIntro.value.data;

const {
  data: legalItems,
  pending,
  error: errorMessage,
  refresh,
} = await useListOfLegalItems();
legalLists.value = legalItems.value.data;

const isArrayOfObjects = Array.isArray(headerData.value.body_text);

useMetaTitles(headerData.value, "legal-and-privacy");

const breadcrumbs = getBreadcrumbs("legal-and-privacy");
</script>
